// action
import {
  profileSuccess,
  profileError,
  resetProfileFlagChange,
  saveDocumentsEntity,
} from "./reducer";
import {
  getDocumentsEntity,
  getUserById,
  postDocumentsByEntity,
  updateUserInfoProfile,
} from "../../../helpers/dataBackend";
import { AppDispatch } from "slices";
import { toast } from "react-toastify";

export const fetchUsersInfo =
  (user_id: number) => async (dispatch: AppDispatch) => {
    try {
      const response = await getUserById(user_id);
      dispatch(profileSuccess(JSON.parse(response.data)));
    } catch (error: any) {
      dispatch(profileError(error));
    }
  };

export const editProfile = (user: any) => async (dispatch: any) => {
  try {
    const response = await updateUserInfoProfile(user);
    // alert("Profile updated Successfully");
    if (response) {
      toast.success("Profile updated Successfully", { autoClose: 2000 });
    }
    dispatch(profileSuccess(response));
    return response;
  } catch (error) {
    console.log(error);
    dispatch(profileError(error));
    return error;
  }
};

export const resetProfileFlag = () => {
  try {
    const response = resetProfileFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const sendDocumentEntity =
  (data: any) => async (dispatch: AppDispatch) => {
    try {
      const response = await postDocumentsByEntity(data);
      if (response) {
        // console.log(response);
        toast.success("Documents Save Successfully", { autoClose: 2000 });
        // dispatch(saveDocumentsEntity(response));
      }
    } catch (error) {}
  };

export const getDocuments = async () => {
  try {
    const response = await getDocumentsEntity();
    console.log(response);
    return response;
  } catch (error) {
    console.log(error);
  }
};
